import FormWizard from './partials/FormWizard.vue'
import TabContent from './partials/TabContent.vue'
import WizardButton from './partials/WizardButton.vue'
import WizardStep from './partials/WizardStep.vue'
const VueFormWizard = {
  install (Vue) {
    Vue.component('form-wizard', FormWizard)
    Vue.component('tab-content', TabContent)
    Vue.component('wizard-button', WizardButton)
    Vue.component('wizard-step', WizardStep)
  }
}
// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(VueFormWizard)
}

export default VueFormWizard
export {
  FormWizard,
  TabContent,
  WizardButton,
  WizardStep
}
